import 'es6-promise/auto'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Meta from 'vue-meta'
import store from './store'
import router from './router'
import Velocity from 'velocity-animate'

// import 'vue-awesome/icons'
// import Icon from 'vue-awesome/components/Icon'
// import icons from './icons'
import VueSVGIcon from 'vue-svgicon'
import 'vue-svgicon/dist/polyfill'
import 'babel-polyfill';
// import fontawesome from '@fortawesome/fontawesome'
// let $ = require('jQuery');
import $ from 'jquery';

window.jQuery = $;
import FullCalendar from 'vue-full-calendar'

Vue.use(Meta)
Vue.use(FullCalendar)
Vue.config.productionTip = false

require('./styles/global.scss')

import { scrollHandler, resizeHandler, customFunctions, connectionCheck} from './mixins/index.js'

Vue.mixin(scrollHandler)
Vue.mixin(resizeHandler)
Vue.mixin(customFunctions)
Vue.mixin(connectionCheck)

// import fontawesome from '@fortawesome/fontawesome'
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
// import solid from '@fortawesome/fontawesome-free-solid'
// import regular from '@fortawesome/fontawesome-free-regular'
// fontawesome.library.add(regular)

// Vue.component('font-awesome-icon', FontAwesomeIcon)

// Vue.component('icon', Icon)
Vue.use(VueSVGIcon)
import './icons'

const vueSmoothScroll = require('vue-smoothscroll');
Vue.use(vueSmoothScroll);
import VueFuse from 'vue-fuse'

Vue.use(VueFuse)
/* eslint-disable no-new */

$('document').ready(function () {

})

new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})
window.addEventListener("load", function (event) {
    // here is the Vue code
});



// WEBPACK FOOTER //
// ./src/main.js